import React from 'react';
import Moment from 'react-moment';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import Button from '../../../../components/button/button';
import './auto-save-message.css';

const FormatCurrentTime = ({ children }) => <Moment format="hh:mm A">{children}</Moment>;

const AutoSaveMessage = (props) => {
  let { savedStatus, infoHoverMessage } = '';
  const {
    message,
    serviceTermAuthorableContent,
    saveNowClickHandler,
    dataSavedTime,
  } = props;
  const {
    autoSaveInitiateText,
    autoSaveInProcessText,
    autoSaveCompletedText,
    autoSaveInitiateToolTipText,
    autoSaveInProcessToolTipText,
    autoSaveCompletedToolTipText,
    saveNowButtonText,
  } = serviceTermAuthorableContent;

  switch (message) {
    case 'saving':
      savedStatus = autoSaveInProcessText;
      infoHoverMessage = autoSaveInProcessToolTipText;
      break;
    case 'saved': {
      savedStatus = autoSaveCompletedText;
      infoHoverMessage = autoSaveCompletedToolTipText;
      break;
    }
    default:
      savedStatus = autoSaveInitiateText;
      infoHoverMessage = autoSaveInitiateToolTipText;
      break;
  }

  return (
    <div>
      {message &&
        <div className="ri-display-save-status">
          {message === 'saved' &&
            <span>
              {savedStatus}
              <FormatCurrentTime>{dataSavedTime}</FormatCurrentTime>
            </span>
          }
          {message !== 'saved' &&
            <span>
              {savedStatus}
            </span>
          }
          {message !== 'saving'
          &&
          <Button
            className="button do-business clear"
            buttonText={saveNowButtonText}
            onClick={saveNowClickHandler}
          />
          }
          <TextWithTooltip
            text={<i className="td-icon icon-information" />}
            textClassName="help-icon-container"
            id="auto-save-tooltip"
            toolTipText={infoHoverMessage}
          />
        </div>
      }
    </div>
  );
};

export default AutoSaveMessage;
